import { StatusBadge } from "@/components/cinch/StatusBadge";

import type { SignalOut } from "../api";

/** Early signals (spec §4.2b) — the quiet heads-up tier. Chips, not rows:
 *  they never demand disposition and most days this renders nothing, which
 *  is the point. Confidence rises night over night as the day matures. */
export function SignalStrip({
  signals,
  onOpen,
}: {
  signals: SignalOut[];
  onOpen: (s: SignalOut) => void;
}) {
  if (signals.length === 0) return null;
  return (
    <div className="rounded-md border border-warning/30 bg-warning/5 px-3 py-2">
      <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        Early signals — days still maturing that are tracking badly
      </p>
      <div className="flex flex-wrap gap-2">
        {signals.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onOpen(s)}
            className="inline-flex items-center gap-2 rounded-md border bg-card px-2.5 py-1.5 text-left text-xs hover:bg-muted"
          >
            <StatusBadge value={s.confidence} />
            <span className="font-medium">{s.key_path}</span>
            <span className="text-muted-foreground">{reason(s)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export function reason(s: SignalOut): string {
  const parts: string[] = [];
  if (s.shortfall_pct != null) {
    parts.push(`tracking ${Math.round(s.shortfall_pct)}% below usual pace`);
  }
  if (s.expected_completeness != null) {
    parts.push(`day ~${Math.round(s.expected_completeness * 100)}% delivered`);
  }
  parts.push(`${s.event_date}`);
  return parts.join(" · ");
}
